<div class="spreadsheet-board-editor">
  <!-- Header Section -->
  <div class="board-editor-header">
    <h2>{{ mode === 'create' ? 'Create Spreadsheet Board' : 'Edit Spreadsheet Board' }}</h2>
    
    <div class="board-details-inline">
      <mat-form-field appearance="outline" class="board-input">
        <mat-label>Board Name</mat-label>
        <input matInput [(ngModel)]="board.userBoardName" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="board-input">
        <mat-label>Board Description</mat-label>
        <input matInput [(ngModel)]="board.userBoardDescription" />
      </mat-form-field>
    </div>

    <div class="board-dimensions-section">
      <h4>Grid Dimensions</h4>
      <div class="dimensions-inputs">
        <mat-form-field appearance="outline" class="dimension-input">
          <mat-label>Rows</mat-label>
          <input matInput 
                 type="number" 
                 min="5" 
                 max="100" 
                 [(ngModel)]="pendingGridRows" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="dimension-input">
          <mat-label>Columns</mat-label>
          <input matInput 
                 type="number" 
                 min="3" 
                 max="26" 
                 [(ngModel)]="pendingGridColumns" />
        </mat-form-field>

        <button 
          mat-raised-button 
          color="primary" 
          (click)="applyDimensionChanges()"
          [disabled]="!hasDimensionChanges()"
          class="apply-dimensions-btn">
          <mat-icon>check</mat-icon>
          Apply Changes
        </button>

        <div class="dimensions-info">
          <mat-icon>info</mat-icon>
          <span>Active grid: {{ gridRows }} × {{ gridColumns }} ({{ gridRows * gridColumns }} cells)</span>
          <span *ngIf="hasDimensionChanges()" class="pending-changes">
            → Will become: {{ pendingGridRows }} × {{ pendingGridColumns }} ({{ pendingGridRows * pendingGridColumns }} cells)
          </span>
        </div>
      </div>
      
      <div class="dimensions-help">
        <small>Rows: 5-100 • Columns: 3-26 (A-Z) • Existing data will be preserved when expanding grid</small>
      </div>
    </div>
  </div>

  <!-- Toolbar -->
  <div class="toolbar">
    <div class="toolbar-left">
      <div class="selection-info">
        {{ getSelectionInfo() || 'Select cells to add content' }}
      </div>
      
      <div class="content-type-buttons">
        <button 
          mat-stroked-button 
          color="primary" 
          (click)="addStaticText()"
          [disabled]="!currentSelection"
          matTooltip="Add static text to selected cell(s)">
          <mat-icon>text_fields</mat-icon>
          Text
        </button>
        
        <button 
          mat-stroked-button 
          color="primary" 
          (click)="addMetric()"
          [disabled]="!canAddMetric()"
          matTooltip="Add metric to selected cell">
          <mat-icon>analytics</mat-icon>
          Metric
        </button>
        
        <button 
          mat-stroked-button 
          color="primary" 
          (click)="addTable()"
          [disabled]="!canAddTable()"
          [matTooltip]="getTableButtonText() === 'Edit Table' ? 'Edit selected table' : 'Add table to selected range'">
          <mat-icon>table_chart</mat-icon>
          {{ getTableButtonText() }}
        </button>
        
        <button 
          mat-stroked-button 
          (click)="clearContent()"
          [disabled]="!currentSelection"
          matTooltip="Clear selected content">
          <mat-icon>clear</mat-icon>
          Clear
        </button>
      </div>
    </div>

    <div class="toolbar-right">
      <button mat-raised-button color="primary" (click)="save()">Save Board</button>
      <button mat-button (click)="cancel()">Cancel</button>
    </div>
  </div>

  <!-- Spreadsheet Grid -->
  <div class="spreadsheet-container">
    <bhub-spreadsheet-grid
      [data]="spreadsheetData"
      [isEditable]="true"
      (selectionChanged)="onSelectionChanged($event)"
      (cellDoubleClick)="onCellDoubleClick($event)">
    </bhub-spreadsheet-grid>
  </div>

  <!-- Status Bar -->
  <div class="status-bar">
    <div>
      <span>Ready</span>
      <span *ngIf="currentSelection"> • {{ getSelectionInfo() }}</span>
    </div>
    <div>
      {{ spreadsheetData.rowCount }}R × {{ spreadsheetData.columnCount }}C
    </div>
  </div>
</div>